const strings = {
    rolePermissions: {
        apiConsumed:[
            "GET/apikeys",
            "POST/apikeys",
            "GET/apikeys/user/<userId>",
            "GET/apikeys/<apiId>/<keyType>",
            "DELETE/apikeys/<apiId>/<keyType>",
        ],
        savedApis:[
            "GET/saved-apis",
            "GET/saved-apis/<apiId>",
            "POST/saved-apis/<apiId>",
            "DELETE/saved-apis/<apiId>"
        ],
        consumerConsumptionReport:[
            "POST/consumer-consumption-report",
            "DELETE/consumer-consumption-report/<id>",
            "GET/consumer-consumption-report/user/<userId>",
        ],
        apis: [
            "GET/admin-apis",
            "POST/admin-apis",
            "GET/admin-apis/<id>",
            "DELETE/admin-apis/<id>",
            "PUT/admin-apis/<id>",
            "GET/admin-apis/invisivel/<id>", 
            "GET/admin-apis/published/<id>",
            "GET/admin-apis/swagger/<id>",
            "POST/admin-apis/swagger/<id>",
            "PUT/admin-apis/swagger/<id>",
            "DELETE/plans-api/<id>",
            "POST/plans-api",
            "PUT/plans-api/<id>",
            "DELETE/groups-api/<id>",
            "GET/groups-api",
            "POST/groups-api",
            "PUT/groups-api/<id>"
        ],
        approval: [
            "GET/activated-apis",
            "GET/activated-apis/<apiId>",
            "POST/activated-apis",
            "PUT/activated-apis/<id>"
        ],
        users:[
            'GET/user',
            'POST/user/create-user',
            'GET/apikeys/user/<userId>',
            'PUT/user/create-user'
        ],
        category: [
            "POST/categories",
            "PUT/categories/<id>",
            "DELETE/categories/<id>"
        ],
        consumptionReport: [
            "GET/consumption-report/user/<userId>",
            "POST/consumption-report",
            "DELETE/consumption-report/<id>"
        ],
        institutionSettings: [
            "DELETE/institutions/<id>",
            "POST/institutions",
            "PUT/institutions/<id>",
            "DELETE/institution-contact/<id>"
        ],
        account:[
            "PUT/user"
        ],
    },
    requestColor: {
        GET: "#61AFFE",
        POST: "#49CC90",
        PUT: "#FCA130",
        DELETE: "#F93E3E",
        PATH: "#50E3C2",
        OPTIONS: "#0d5aa7"
    },
    apiStatusValue: {
        inRegistration: {value: 0, label: 'Em cadastro'},
        published: {value: 1, label: 'Publicada'},
        invisible: {value: 2, label: 'Invisível'},
    },
    apiStatusLabel: {
        0: 'Em cadastro',
        1: 'Publicada',
        2: 'Invisível'
    }
}

export default strings
